import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, runInAction } from 'mobx';

import { ApiClient, CommentShortDto } from '@app/Models/WebApiModels';
import { Loading } from '@app/Components';
import { PromiseCompletion } from '@app/Classes/PromiseCompletion';
import { applyDecorators } from "@app/Helpers/Decorator";


type CommentsProps = {
    ids?: string[];
    personId?: string;
    date?: Date | null;
};

@observer
export default class Comments extends React.Component<CommentsProps> {
    private _apiClient: ApiClient = new ApiClient();
    private readonly _loading: PromiseCompletion;

    @observable private _comments: CommentShortDto[] = [];

    constructor(props: CommentsProps) {
        super(props);
        applyDecorators(this);
        this._loading = new PromiseCompletion();
    }

    componentDidMount() {
        void this._loadData();
    }

    private async _loadData() {
        const { ids, personId, date } = this.props;
        if (ids) {
            const { data } = await this._apiClient.commentGet({ commentsIds: ids }, { completion: this._loading });
            runInAction(() => {
                this._comments = data;
            });
        }
        if (personId && date) {
            const { data } = await this._apiClient.commentPersonGet({ personId: personId, date: date }, { completion: this._loading });
            runInAction(() => {
                this._comments = data.map(x => { return { id: x.commentId || '', text: x.text }; });
            });
        }
    }

    render() {
        return (
            <div>
                <Loading loading={this._loading.isPending} small />

                {!!this._comments.length && <>
                    {this._comments.map((x, i) => <div className='comment' key={'comment_' + i}><i>"{x.text}"</i></div>)}
                </>}
            </div>
        );
    }
}
